import React from 'react';

import {Button} from '../../../../../Button';
import {Tooltip} from '../../../../../Tooltip';
import {A} from '../common/Links';
import {useComparisonView} from './ComparisonViewContext';
import {DropdownComparisonViewActions} from './DropdownComparisonViewActions';
import {SavedViewSuffixTimestamp} from './SavedViewSuffixTimestamp';

type ComparisonViewSuffixProps = {
  isReadonly: boolean;
};

export const ComparisonViewSuffix = ({
  isReadonly,
}: ComparisonViewSuffixProps) => {
  const {
    baseView,
    isModified,
    isSaving,
    onSaveView,
    onSaveNewView,
    onResetView,
    onDeleteView,
  } = useComparisonView();

  const createAt = baseView?.created_at;

  return (
    <div className="flex items-center gap-8">
      {isModified && baseView ? (
        <Tooltip
          content="Reset comparison to last saved state"
          trigger={
            <A $variant="primary" onClick={onResetView}>
              Reset comparison
            </A>
          }
        />
      ) : createAt ? (
        <div className="mr-8 text-moon-500 line-clamp-1">
          Saved on <SavedViewSuffixTimestamp createdAt={createAt} />
        </div>
      ) : null}
      {!isReadonly && (
        <>
          <DropdownComparisonViewActions
            baseView={baseView}
            onSaveNewView={onSaveNewView}
            onDeleteView={onDeleteView}
          />
          <Button
            disabled={!isModified || isSaving}
            onClick={() => onSaveView()}
            className="-mr-8">
            Save comparison
          </Button>
        </>
      )}
    </div>
  );
};
